// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__H-BdQ","title":"Style_title__2n-Sq","detail":"Style_detail__26eCr","options":"Style_options__2jG3E"};